module.exports = __webpack_public_path__ + "img/instagram-post.b5c038e9.png";